export const statusClassMap = {
  EXPIRED: "bg-danger",
  WARNING: "bg-warning",
  VALID: "bg-success",
}; 